import { Typography } from "@mui/material";
import type { FreightMatching } from "@x-mile/api-contract";

type Props = {
  type: FreightMatching.schemas.NotificationPayload["type"];
};

const DELIVERY_COLOR = "#7E96E5";
const CONTRACT_COLOR = "#F2CB30";

const colors: {
  [key in FreightMatching.schemas.NotificationPayload["type"]]: string;
} = {
  delivery_proposal_created: DELIVERY_COLOR,
  delivery_proposal_rejected: DELIVERY_COLOR,
  contract_proposal_created: CONTRACT_COLOR,
  contract_proposal_rejected: CONTRACT_COLOR,
  contract_concluded_created: CONTRACT_COLOR,
  delivery_request_files_uploaded: CONTRACT_COLOR,
};

const labels: {
  [key in FreightMatching.schemas.NotificationPayload["type"]]: string;
} = {
  delivery_proposal_created: "提案",
  delivery_proposal_rejected: "提案",
  contract_proposal_created: "契約",
  contract_proposal_rejected: "契約",
  contract_concluded_created: "契約",
  delivery_request_files_uploaded: "契約",
};

export const NotificationTypeLabel = ({ type }: Props) => {
  return (
    <div
      style={{
        backgroundColor: colors[type],
        width: 72,
        height: 28,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography fontSize="14px" color="white">
        {labels[type]}
      </Typography>
    </div>
  );
};
